var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaqabiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#030912"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4015 9.50117L28.9793 14.5203C29.4101 14.7723 29.6755 15.2382 29.6755 15.7424V25.7806C29.6755 26.2848 29.4101 26.7506 28.9793 27.0027L25.275 29.1702V16.2457C25.275 15.0766 24.3399 14.1289 23.1864 14.1289V19.6325H16.2242V11.1307L19.0091 9.50117C19.4399 9.24908 19.9707 9.24908 20.4015 9.50117ZM16.2242 21.7493V27.3941C15.0707 27.3941 14.1356 26.4464 14.1356 25.2773V12.3528L10.4314 14.5203C10.0005 14.7723 9.73513 15.2382 9.73513 15.7424V25.7806C9.73513 26.2848 10.0005 26.7506 10.4313 27.0027L19.0091 32.0218C19.4399 32.2739 19.9707 32.2739 20.4015 32.0218L23.1864 30.3923V21.7493H16.2242ZM17.9648 7.66797C19.0418 7.03776 20.3688 7.03776 21.4458 7.66797L30.0236 12.6871C31.1006 13.3173 31.7641 14.482 31.7641 15.7424V25.7806C31.7641 27.041 31.1006 28.2057 30.0236 28.8359L21.4458 33.855C20.3688 34.4852 19.0418 34.4852 17.9648 33.855L9.38703 28.8359C8.30997 28.2057 7.64648 27.041 7.64648 25.7806V15.7424C7.64648 14.482 8.30997 13.3173 9.38703 12.6871L17.9648 7.66797Z",
    fill: "#C4F538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaqabiLogo);
export default __webpack_public_path__ + "static/media/haqabi-logo.ef18dff35a060938548be5e48d40454a.svg";
export { ForwardRef as ReactComponent };